import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import Stack from "./pages/Stack";
import Nsite from "./pages/Nsite";
import GetStarted from "./pages/GetStarted";
import Nori from "./pages/Nori";
import Nvpn from "./pages/Nvpn";
import Ngit from "./pages/Ngit";
import NostrMail from "./pages/NostrMail";
import Security from "./pages/Security";
import Client from "./pages/Client";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/get-started" element={<GetStarted />} />
        <Route path="/stack" element={<Stack />} />
        <Route path="/nsite" element={<Nsite />} />
        <Route path="/nori" element={<Nori />} />
        <Route path="/client" element={<Client />} />
        <Route path="/nvpn" element={<Nvpn />} />
        <Route path="/ngit" element={<Ngit />} />
        <Route path="/nostr-mail" element={<NostrMail />} />
        <Route path="/security" element={<Security />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;